import { render } from "./BlocksEdit.vue?vue&type=template&id=388bc599&scoped=true"
import script from "./BlocksEdit.vue?vue&type=script&lang=js"
export * from "./BlocksEdit.vue?vue&type=script&lang=js"

import "./BlocksEdit.vue?vue&type=style&index=0&id=388bc599&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388bc599"]])

export default __exports__